export default [
    {
        path: '/faqs',
        name: 'faqs',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Faqs.vue')
    }
]